import React from 'react';
import './Testimonios.css';
import KarinaCamacho from '../assets/Karina_Camacho.jpg';
import DianaAguilar from '../assets/Diana_Aguilar.jpg';
import AndresMora from '../assets/Andres_Mora.jpg';



const testimonios = [
  {
    nombre: 'Dra. Diana Aguilar',
    especialidad: 'Medicina General',
    foto: DianaAguilar,
    comentario: 'Por el precio me parece que es una plataforma bastante completa y fácil de usar, no tuve que ver videos para aprender a usarla. El equipo de soporte es muy rápido atendiendo.',
  },
  {
    nombre: 'Dr. Andrés Mora',
    especialidad: 'Medicina General',
    foto: AndresMora,
    comentario: 'Adaptarme fue mucho más fácil de lo que esperaba. Es una buena opción por el precio y cumple con lo necesario para las consultas diarias.',
  },
  {
    nombre: 'Dra. Karina Camacho',
    especialidad: 'Pediatría',
    foto: KarinaCamacho,
    comentario: 'Lo que más me gustó es que no es una plataforma complicada, aprendí muy rápido y he podido llevar el seguimiento de mis pacientes sin problema.',
  }
];

//const comunidadFotos = [
 // "https://images.unsplash.com/photo-1603398938378-5c33b47fde5a", // doctor hombre
 // "https://images.unsplash.com/photo-1607746882042-944635dfe10e", // doctora mujer
 // "https://images.unsplash.com/photo-1612349317150-5b2a9c4aaf57", // doctor joven
 // "https://images.unsplash.com/photo-1550831107-1553da8c8464",     // doctora mayor
 // "https://images.unsplash.com/photo-1578496481275-15a9f3bca4c4", // doctor con bata
 // "https://images.unsplash.com/photo-1622253692010-4f2b70c0c324", // doctora con estetoscopio
 // "https://images.unsplash.com/photo-1579154203451-d53a707b1b04", // doctor con fondo hospital
 // "https://images.unsplash.com/photo-1629904853716-f0bc54f9d490", // doctora sonriendo
 // "https://images.unsplash.com/photo-1537368910025-700350fe46c7", // doctor con brazos cruzados
 // "https://images.unsplash.com/photo-1584467735871-bfb7f35b6d9e", // doctora confiada
//];

function Testimonios() {
  return (
    <section className="testimonios">
     <div className="testimonios-container">
        <h3>Bienvenido a la comunidad de profesionales de la salud que crece contigo. Más de 1,000 doctores ya confían en Salvir para cuidar a sus pacientes. Únete tú también.</h3>
      <div className="testimonios-grid">
        {testimonios.map((t, i) => (
          <div className="testimonio" key={i}>
            <img src={t.foto} alt={`Foto de ${t.nombre}`} />
            <h4>{t.nombre}</h4>
            <p className="especialidad">{t.especialidad}</p>
            <p className="comentario">“{t.comentario}”</p>
          </div>
        ))}
      </div>
      
      {/*<div className="comunidad-circulos">
        {comunidadFotos.map((src, i) => (
          <img key={i} src={src} alt="Doctor" className="circulo" />
        ))}
      </div>*/}
     </div>
      
    </section>
  );
}

export default Testimonios;
